import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import RoleSettings from '../Roles/RoleSettings';

import ErrorBoundary from '../../ErrorBoundary';

const AdminTaxonomyEditSettings = ({
  entity,
  entityId,
  handleChangeRole,
  handleDelete,
  ...props
}) => {
  const intl = useIntl();

  const handleChange = (roleId, permission, checked) => {
    handleChangeRole(roleId, permission, checked);
  };

  const permissions = [
    {
      key: 'can_view',
      label: intl.formatMessage({ defaultMessage: 'View' }),
    },
    {
      key: 'can_add',
      label: intl.formatMessage({ defaultMessage: 'Add new tags' }),
    },
    {
      key: 'read_only',
      label: intl.formatMessage({ defaultMessage: 'Read-only' }),
    },
  ];

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <div>
          <p>
            {intl.formatMessage({ defaultMessage: 'Manage user role permissions' })}
          </p>
          <div className="settings-permissions">
            <RoleSettings
              permissions={permissions}
              handleChangeRole={handleChange}
              entity={entity}
              entityType="taxonomy"
            />
          </div>
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Tag Category' })}
        hideDelete={entityId === null}
        handleDelete={handleDelete}
      />
    </ErrorBoundary>
  );
};

AdminTaxonomyEditSettings.propTypes = {
  entity: PropTypes.object,
  entityId: PropTypes.string,
  handleChangeRole: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

AdminTaxonomyEditSettings.defaultProps = {
  entity: null,
  entityId: null,
};

export default AdminTaxonomyEditSettings;
